


<div class="custom-icon" [ngStyle]="{'height': size+sizeUnit, 'width': size+sizeUnit, 'background-image': 'url(../../assets/icons/'+icon+'.png)'}"></div>